<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="edit-box"
      :class="isArrowVisible ? 'arrow' : ''"
      :style="'top: ' + yPos + 'px; left: ' + xPos + 'px;'"
    >
      <div class="edit-box__inner">
        <div>
          <slot name="input"></slot>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="clickRemove"
          >
            Remove
          </button>
          <button
            class="btn btn-sm btn-primary float-right"
            @click="clickUpdate"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'modal-edit-box',

  props: {
    xPos: 0,
    yPos: 0,
    isVisible: false,
    isArrowVisible: true
  },
  
  methods: {
    clickUpdate() {
      this.$emit('update');
    },

    clickRemove() {
      this.$emit('remove');
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-box {
  background: #212120;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(#000, .7);
  color: #fff;
  opacity: 1;
  pointer-events: auto;
  position: absolute;
  transition: 200ms all ease-in-out;
  width: 250px;
  z-index: 100;

  &__inner {
    padding: 20px;
  }

  &.arrow::before {
    content: '';
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 0; 
    height: 0; 
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #212120;
  }
}

.fade-enter-active {
  opacity: 1;
  transform: rotate3d(0, 0, 0, 0deg);
}
.fade-leave-active {
  transition: all 200ms cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: rotate3d(-.3, 1, 0, 20deg);
}
</style>
